import "../styles/trustpilot.css";
import Slider from "react-slick";

const TrustPilot = (props) => {
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="trustPilotContainer">
        <div className="trustPilotHeading text-bold">What Our Clients Say</div>
        <Slider {...settings}>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">17/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Straightforward process</p>
              <p className="trustPilotCopy">
              You are professional and have made everything easy and straightforward and update on a regular basis.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Anne-Marie</p>
          </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">17/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Keeping me informed</p>
              <p className="trustPilotCopy">
              All the while you have been dealing with my claim you have always kept me informed with everything that is going on.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Mr Anthony Elworthy</p>
          </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">17/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">You are keeping me well informed on…</p>
              <p className="trustPilotCopy">
              You are keeping me well informed on each procedure with this claim and are very pleased that you are looking after me.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Mr Brown</p>
          </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">16/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Kept well informed throughout the…</p>
              <p className="trustPilotCopy">
              Kept well informed throughout the process and given plenty of time to respond.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Sanjay Patel</p>
          </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">16/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Smooth experience throughout the…</p>
              <p className="trustPilotCopy">Smooth experience throughout the questionnaire, quick and easy.</p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Glenn B.</p>
          </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">15/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Great people</p>
              <p className="trustPilotCopy">
                Great people.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Graham</p>
              </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">12/07/2024</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Can’t fault them</p>
              <p className="trustPilotCopy">
              Stayed in touch and kept me up to date.
              </p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Susan Emily</p>
            </div>
          </div>
          <div className="trustPilotCard">
            <div className="trustPilotCardTop">
              <img src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/stars-5.svg" alt="stars" />
              <p className="trustPilotCopy ">11/03/2023</p>
            </div>
            <div className="trustPilotCcardContent">
              <p className="trustPilotLegend text-bold">Everything has been straightforward and…</p>
              <p className="trustPilotCopy">Everything has been straightforward and I have had plenty of emails updating me with what’s going on with my claim.</p>
              <div className="trustPilotLine"></div>
              <p className="trustPilotCopy text-bold">Terry Butcher</p>
            </div>
          </div>
        </Slider>
      </div>
    </>
  );
};

export default TrustPilot;
